module.exports = __webpack_public_path__ + "static/media/planet.1ba19c3e.jpg";